// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { stopOverlayAnimation } from '../../../actions/overlay';
import useBindActionsCreator from '../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../hooks/useMergeProps';
import OverlayAnimation from '../components/OverlayAnimation';
import selectOverlayAnimationProps from '../selectors/OverlayAnimation.selector';

type OverlayAnimationContainerProps = {
  className?: string;
};

const OverlayAnimationContainer = (ownProps: OverlayAnimationContainerProps) => {
  const actions = useMemo(
    () => ({
      endAnimation: () => stopOverlayAnimation(),
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const selectedProps = useSelector(selectOverlayAnimationProps);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return <OverlayAnimation {...enhancedProps} />;
};

export default OverlayAnimationContainer;
